import {diary, enable} from 'diary'
import type {Reporter} from 'diary'
export type {Diary as ILogger} from 'diary'

// Enable all logs to output for now
enable('*')

export const logger = (name: string, onEmit?: Reporter) => diary(name, onEmit)
